import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DialogHost } from '@components/partials/dialog-host/dialog-host';
import { SnackbarHost } from '@components/partials/snackbar-host/snackbar-host';
import { ThemeService } from '@services/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DialogHost, SnackbarHost],
  template: `
    <router-outlet />
    <app-dialog-host />
    <app-snackbar-host />
  `,
})
export class App {
  private readonly themeService = inject(ThemeService);
}
